import store from '@/store'
export async function Api(method, url, { params = null, body = null } = {}) {
  if (store.state.axiosControllers[url]) {
    store.state.axiosControllers[url].abort()
  }

  store.state.axiosControllers[url] = new AbortController()

  try {
    const response = await axios.request({
      method,
      url,
      params,
      data: body,
      signal: store.state.axiosControllers[url].signal,
    })
    if (response)
      response.last_request = !store.state.axiosControllers[url].signal.aborted

    return response
  } catch (error) {
    if (error) {
      error.last_request = !store.state.axiosControllers[url].signal.aborted
    }
    if(error.code !== 'ERR_CANCELED') {
      throw error
    }
  }
}
